import React from 'react';
import { Helmet } from 'react-helmet-async';

const ORIGIN = 'https://offert.klarthemma.com';

/** Title, description, canonical and social tags for one page. */
export default function PageMeta({ title, description, path, noindex = false }) {
  const url = path ? `${ORIGIN}${encodeURI(path)}` : null;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      {url && !noindex && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {url && !noindex && <meta property="og:url" content={url} />}
    </Helmet>
  );
}
